__webpack_require__.p = "https://static.paymentiq.io/cashier-config/";